import delimiter from './delimiter';

export default function money(val, precision = 0, currency = 'Rp') {
  const int = delimiter(Number(val) || 0, precision);
  if (int.charAt(0) === '-') {
    return int.replace(/^-/g, `-${currency}`);
  }
  return `${currency}${int}`;
}
